import api from "@/api";

const state = {
    events: [],
};

const getters = {
    events: state => state.events || [],
};

const actions = {
    async getEvents({ commit }) {
        const res = await api.get("/api/google-calendar/events");
        commit("updateEvents", { events: res.data.events });
    },
    async clearEvents({ commit }) {
        commit("updateEvents", { events: [] });
    },
    async startAuth(_ignoreMe, { redirect }) {
        const res = await api.get(
            `/api/google-calendar/auth/init?redirect=${encodeURIComponent(redirect)}`,
        );
        window.location = res.data.url;
    },
};

const mutations = {
    updateEvents(state, { events }) {
        state.events = events;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
